export const LOGO_URL = "/logo-figaro.png";

export const Logo = ({ className = "h-6", testId = "figaro-logo" }) => (
  <img src={LOGO_URL} alt="Figaro Busch" data-testid={testId} className={`${className} w-auto object-contain`} />
);
